import "./BatchCooking.module.css";
import Navigation from "@/reusable_sections/Header";
import Saveurs from "./sections/Saveurs";
import Culinaryphilosophy from "./sections/Culinaryphilosophy";
import Process from "./sections/Process";
import BatchCookingPricing from "./sections/BatchCookingPricing";
import PostnatalServiceDetails from "./sections/PostnatalServiceDetails";
import PostnatalServiceInclusions from "./sections/PostnatalServiceInclusions";
import Giftcardshowcase from "./sections/Giftcardshowcase";
import Footer from "@/reusable_sections/Footer";
export default function BatchCookingPage() {
  return <div>
      <Navigation />
      <Saveurs />
      <Culinaryphilosophy />
      <Process />
      <BatchCookingPricing />
      <PostnatalServiceDetails />
      <PostnatalServiceInclusions />
      <Giftcardshowcase />
      <Footer />
    </div>;
}